/* eslint-disable no-restricted-syntax */
/* eslint-disable react/prop-types */
import React, { useEffect, useRef, useState } from 'react';
import Editor from '@monaco-editor/react';
import { Button } from '@mui/material';
// import CodeEditorHeader from '../CodeEditorHeader/CodeEditorHeader';
import { MONACO_EDITOR_FONT_SIZE } from '../../../../lib/consts';
import '../CodeEditorLayout.scss';
import { getFilesEditorHeight } from '../codeEditor.helper';

const CodeEditorFiles = ({
	field,
	onEditorChange,
	isExpanded,
	isHorizontalView,
}) => {
	const files = {};

	const fields = ['html', 'css', 'scss', 'js'];
	let defaultFile = '';
	for (const fileName of fields) {
		if (field?.options?.[fileName]) {
			defaultFile = fileName;
			break;
		}
	}
	const [currentFile, setCurrentFile] = useState(defaultFile);
	const [height, setHeight] = useState('300px');

	if (field?.options && Object.hasOwn(field.options, 'html')) {
		files.html = {
			name: 'html',
			language: 'html',
			value: field?.options?.html || '',
		};
	}
	if (field?.options && Object.hasOwn(field.options, 'css')) {
		files.css = {
			name: 'css',
			language: 'css',
			value: field?.options?.css || '',
		};
	}
	if (field?.options && Object.hasOwn(field.options, 'js')) {
		files.js = {
			name: 'js',
			language: 'js',
			value: field?.options?.js || '',
		};
	}
	if (field?.options && Object.hasOwn(field.options, 'scss')) {
		files.scss = {
			name: 'scss',
			language: 'scss',
			value: field?.options?.scss || '',
		};
	}

	useEffect(() => {
		const filesArray = Object.keys(files);
		if (filesArray.length) {
			setCurrentFile(filesArray[0]);
		}
	}, []);

	const htmlEditorRef = useRef(null);
	const cssEditorRef = useRef(null);
	const scssEditorRef = useRef(null);
	const jsEditorRef = useRef(null);

	useEffect(() => {
		setTimeout(() => {
			setHeight(getFilesEditorHeight(isExpanded, false));
		}, 500);
	}, [isExpanded, isHorizontalView]);

	const updateEditorCallback = (editor) => {
		editor.updateOptions({
			fontSize: MONACO_EDITOR_FONT_SIZE,
			automaticLayout: true,
		});
	};

	const handleEditorDidMountHTML = (editor) => {
		updateEditorCallback(editor);
		htmlEditorRef.current = editor;
	};

	const handleEditorDidMountCSS = (editor) => {
		updateEditorCallback(editor);
		cssEditorRef.current = editor;
	};

	const handleEditorDidMountJS = (editor) => {
		updateEditorCallback(editor);
		jsEditorRef.current = editor;
	};

	const handleEditorDidMountSCSS = (editor) => {
		updateEditorCallback(editor);
		scssEditorRef.current = editor;
	};

	const handleEditorChange = () => {
		const code = {};
		code.html = htmlEditorRef.current?.getValue();
		code.css = cssEditorRef.current?.getValue();
		code.js = jsEditorRef.current?.getValue();
		code.scss = scssEditorRef.current?.getValue();
		const update = {};
		fields.forEach((lang) => {
			if (field?.options && Object.hasOwn(field.options, lang)) {
				update[lang] = code[lang];
			}
		});
		onEditorChange(update);
	};

	return (
		<div className="code-editor-block">
			<div className="code-editor-block-files">
				{Object.keys(files).map((file) => (
					<Button
						size="small"
						className={`code-editor-file-tab ${currentFile === file ? 'active' : ''}`}
						key={file}
						onClick={() => setCurrentFile(file)}
						sx={{ color: '#fff' }}
					>
						{file.toUpperCase()}
					</Button>
				))}
			</div>
			{files.html && (
				<div
					className="code-editor-parts-3"
					style={{ display: currentFile === 'html' ? 'block' : 'none' }}
				>
					{/* <CodeEditorHeader name="HTML" theme="dark" /> */}
					<Editor
						height={height}
						width="100%"
						theme="vs-dark"
						defaultLanguage="html"
						defaultValue={files.html.value}
						onMount={handleEditorDidMountHTML}
						onChange={handleEditorChange}
					/>
				</div>
			)}
			{files.scss && (
				<div
					className="code-editor-parts-3"
					style={{ display: currentFile === 'scss' ? 'block' : 'none' }}
				>
					{/* <CodeEditorHeader name="SCSS" theme="dark" /> */}
					<Editor
						height="300px"
						width="100%"
						theme="vs-dark"
						defaultLanguage="scss"
						defaultValue={files.scss.value}
						onMount={handleEditorDidMountSCSS}
						onChange={handleEditorChange}
					/>
				</div>
			)}
			{files.css && (
				<div
					className="code-editor-parts-3"
					style={{ display: currentFile === 'css' ? 'block' : 'none' }}
				>
					{/* <CodeEditorHeader name="CSS" theme="dark" /> */}
					<Editor
						height="300px"
						width="100%"
						theme="vs-dark"
						defaultLanguage="css"
						defaultValue={files.css.value}
						onMount={handleEditorDidMountCSS}
						onChange={handleEditorChange}
					/>
				</div>
			)}
			{files.js && (
				<div
					className="code-editor-parts-3"
					style={{ display: currentFile === 'js' ? 'block' : 'none' }}
				>
					{/* <CodeEditorHeader name="JS" theme="dark" /> */}
					<Editor
						height="300px"
						width="100%"
						theme="vs-dark"
						defaultLanguage="javascript"
						defaultValue={files.js.value}
						onMount={handleEditorDidMountJS}
						onChange={handleEditorChange}
					/>
				</div>
			)}
		</div>
	);
};

export default CodeEditorFiles;
